var _defs, _path, _polygon, _polygon2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 39.57",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3d5629;}.cls-2{fill:#f36c25;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.55,37.82c-.23.05-.45.1-.65.15l-.24,1.6h8.87l-.5-3.35-7.47,1.59Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.47 33.22 10.43 33.02 15.39 31.96 14.65 27.02 9.4 28.14 8.59 33.41 9.47 33.22"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.02 22.76 13.35 18.26 10.88 18.38 10.09 23.59 14.02 22.76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.45,17.92c-.66-1.23-1.1-2.55-1.32-3.93l7.58-1.16c.08.51.24.99.48,1.44l-6.74,3.64h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.48,16.57l-7.14-2.79c.19-.47.29-.98.31-1.5h0s7.66.22,7.66.22h0c-.05,1.41-.32,2.77-.83,4.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.66,12.02L0,11.8h0c.05-1.4.32-2.76.82-4.05l7.15,2.78c-.19.47-.29.98-.3,1.49h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.59,11.46c-.08-.51-.24-.99-.48-1.44l6.74-3.65c.66,1.22,1.11,2.55,1.32,3.92l-7.58,1.17h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.33,9.79L1.81,5.77c.73-1.18,1.65-2.22,2.74-3.09l4.8,5.98c-.41.32-.75.71-1.02,1.15h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.66,9.34c-.32-.41-.71-.75-1.15-1.02l4.03-6.52c1.18.73,2.22,1.65,3.09,2.73l-5.98,4.8h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.02,8.2L6.38,1.45c1.23-.66,2.55-1.11,3.93-1.32l1.16,7.57c-.51.08-.99.24-1.44.48h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.78,7.96c-.47-.18-.97-.28-1.49-.3h-.01S12.51,0,12.51,0h.01c1.39.04,2.75.32,4.04.82l-2.78,7.15h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.98,27.45l2.72-8h.1l2.72,8h-5.54Zm.92-11.15l-6.41,17.68v.26h3.18l1.41-4.15h7.33l1.41,4.15h3.28v-.26l-6.43-17.68h-3.77,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.22,18.83c2.79,0,4.2,1.64,4.43,3.8h3.07c-.33-3.8-3.07-6.56-7.51-6.56-5.41,0-8.25,3.84-8.25,9.23s2.82,9.17,8.25,9.17c4.41,0,7.07-2.69,7.51-6.38h-3.05c-.38,2.13-1.77,3.64-4.46,3.64-3.67,0-5.18-2.82-5.18-6.43s1.51-6.45,5.18-6.45"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.08,24.76h-4.41v-5.74h4.41c1.97,0,2.95,1.18,2.95,2.84s-.95,2.9-2.95,2.9Zm6.05-2.92c0-3.05-2.15-5.54-5.87-5.54h-7.59v17.94h3v-6.76h3.59l4.33,6.76h3.41v-.26l-4.59-6.87c2.26-.74,3.71-2.66,3.71-5.28Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.76,24.76h-4.41v-5.74h4.41c1.97,0,2.95,1.18,2.95,2.84s-.95,2.9-2.95,2.9Zm6.05-2.92c0-3.05-2.15-5.54-5.87-5.54h-7.59v17.94h3v-6.76h3.59l4.33,6.76h3.41v-.26l-4.59-6.87c2.26-.74,3.71-2.66,3.71-5.28Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m116.64,16.3l-5.61,9.79h-.1l-5.61-9.79h-3.41v17.94h2.9v-13.25h.1l5.92,10.22h.26l5.92-10.15h.1v13.17h2.9v-17.94h-3.36Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m18.11,21.33c-.49-1.5-2.01-2.5-3.79-2.5l.41,2.78s.14-.03.33.09c.24.16.27.42.3.7.05.5-.36.98-.94,1.1l-6.7,1.42c-2.08.44-3.55,2.25-3.36,4.12.11,1.06.68,1.98,1.6,2.58.65.43,1.77.65,1.95.62,0,0,.48-2.69.39-2.69-.26,0-.5-.08-.69-.23-.25-.2-.38-.49-.35-.8.04-.44.42-.82.92-.93l6.84-1.45c1.11-.24,2.08-.89,2.66-1.8.6-.93.75-2,.42-3h0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m15.42,14.83c-.2-.94-2.02-1.19-2.96-1.19-.35,0-.66.03-.91.08-.58.12-1.13.45-1.5.89l-.94.2c-1.1.24-2.08.89-2.66,1.8-.6.93-.75,1.99-.42,3,.48,1.5,1.69,2.48,3.47,2.48.09-.59.41-2.76.41-2.76-.09.02-.16.04-.24.04-.23,0-.28,0-.46-.13-.24-.16-.39-.41-.42-.68-.05-.5.36-.98.94-1.11l.97-.21c.33.14.7.22,1.07.22.19,0,.38-.02.56-.06.58-.12,1.39-.5,2.01-.94.57-.4,1.21-1.01,1.08-1.64h0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.27,19.87c-.23-.69-.26-1.41-.12-2.1l-2.48,1.99c.87,1.09,1.91,2.01,3.09,2.74l.54-.87c-.46-.47-.81-1.06-1.03-1.75Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.19,14.65s0,0,0,.01c.09.44.03,1.07-.61,1.78l4.17,5.2c1.09-.87,2.01-1.91,2.74-3.09l-6.3-3.9Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m20.7,30.26c-.49-1.5-2.01-2.5-3.79-2.5-.32,0-.93.09-1.25.16l.39,2.67c.09-.02.73-.13.83-.13.41,0,.78.19.95.51.15.27.16.59,0,.87-.15.29-.44.5-.78.57l-7.41,1.58-1.82.39c-.91.19-1.73.68-2.32,1.36-.09.11-.17.2-.23.29-.18.25-.33.52-.44.81-.04.1-.08.22-.11.35-.08.29-.13.59-.13.88v.41s.34-.21.34-.21c.56-.34,1.62-.83,3.47-1.23l9.23-1.96c1.11-.24,2.08-.89,2.66-1.8.6-.93.75-2,.42-3h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.02b443b6.svg";
export { ForwardRef as ReactComponent };